/**
 * 会话与鉴权请求链路上，前端主动抛出或上报的错误码。
 * 作为 Error.message 或失败原因使用；调用方用这些常量判断，不要再写散落的字符串。
 * 码值保持稳定：埋点、页面分支都按 message 识别。
 */
export enum ESessionErrorCode {
    // —— 会话门闩 ——

    /** login runner 尚未注册，无法发起会话登录。 */
    SESSION_LOGIN_NOT_REGISTERED = 'session_login_not_registered',

    /** 冷启动入口尚未注册，鉴权请求无法等待会话建立。 */
    SESSION_BOOTSTRAP_NOT_REGISTERED = 'session_bootstrap_not_registered',

    /** 冷启动等待超时，与 login / logout 的请求超时一致。 */
    SESSION_BOOTSTRAP_TIMEOUT = 'session_bootstrap_timeout',

    /**
     * 会话有效期没有成功落盘。
     * 此后禁止继续使用旧有效期，也不再自动重复登录，直到后续显式账号操作成功。
     */
    SESSION_EXPIRY_NOT_PERSISTED = 'session_expiry_not_persisted',

    /** 鉴权恢复标记写入本地存储失败，本次恢复中止。 */
    SESSION_RECOVERY_MARK_NOT_PERSISTED = 'session_recovery_mark_not_persisted',

    /** 恢复结束后未能清除恢复标记，或清除后会话仍无效。 */
    SESSION_RECOVERY_MARK_NOT_CLEARED = 'session_recovery_mark_not_cleared',

    // —— 恢复与静默换发上报 ——

    /** 鉴权恢复失败，且抛出的错误没有 message 时的上报兜底。 */
    SESSION_RECOVERY_FAILED = 'session_recovery_failed',

    /** 静默换发发起的 login 失败。 */
    SILENT_LOGIN_FAILED = 'silent_login_failed',

    /** 空闲定时器触发的静默换发任务失败。 */
    SILENT_REFRESH_FAILED = 'silent_refresh_failed',

    // —— 登录、登出与设备注册 ——

    /** 登录或登出时本地没有可用的游客 device_id。 */
    DEVICE_ID_MISSING = 'device_id_missing',

    /** 业务登录失败：服务端未返回 message，或异常被归一成该码。 */
    LOGIN_FAILED = 'login_failed',

    /** 登出失败且服务端未返回 message。 */
    LOGOUT_FAILED = 'logout_failed',

    /** 设备注册失败且服务端未返回 message。 */
    DEVICE_REGISTER_FAILED = 'device register failed',

    /** 游客会话 login 失败且服务端未返回 message。 */
    AUTH_LOGIN_FAILED = 'auth login failed',
}
